<div class="grid grid--va-middle" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected">
  <div class="grid__box grid__box--size-min grid__box--pull-left">
    <div class="grid grid--va-middle">
      <div class="grid__box grid__box--size-min">
        <span class="title"> Заявки в графике </span>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts === 0">
          <span class="color-blue-dark"> Назначено ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts }}) </span>
        </div>
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts > 0">
          <span class="color-blue-dark font-weight-bold" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id === 'assigned'">
            Назначено ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts }})
          </span>
          <a class="link link--dotted-blue-dark" (click)="onChangeTicketType('assigned')" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id !== 'assigned'">
            Назначено ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.assigned.counts }})
          </a>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.unassigned.counts === 0">
          <span class="color-red-dark"> Не назначено ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.unassigned.counts }}) </span>
        </div>
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.unassigned.counts > 0">
          <span class="color-red-dark font-weight-bold" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id === 'unassigned'">
            Не назначено ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.unassigned.counts }})
          </span>
          <a class="link link--dotted-red-dark" (click)="onChangeTicketType('unassigned')" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id !== 'unassigned'">
            Не назначено ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.unassigned.counts }})
          </a>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.needActions.counts === 0">
          <span class="color-red-dark"> Требуют действий ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.needActions.counts }}) </span>
        </div>
        <div *ngIf="ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.needActions.counts > 0">
          <span class="color-red-dark font-weight-bold" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id === 'needActions'">
            Требуют действий ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.needActions.counts }})
          </span>
          <a class="link link--dotted-red-dark" (click)="onChangeTicketType('needActions')" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id !== 'needActions'">
            Требуют действий ({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.needActions.counts }})
          </a>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="color-blue-dark font-weight-bold" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id === 'all'">
          Все({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.all.counts }})
        </span>
        <a class="link link--dotted-blue-dark" (click)="onChangeTicketType('all')" *ngIf="ticketsCurrentFilter.currentFilterTypeSelected.id !== 'all'">
          Все({{ ticketsCurrentFilter.currentFilterTypes && ticketsCurrentFilter.currentFilterTypes.all.counts }})
        </a>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="vertical-separate"></div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="grid grid--va-middle grid--gap-8">
          <div class="grid__box grid__box--size-min">
            <span class="title">Назначить на</span>
          </div>
          <div class="grid__box grid__box--size-min">
            <div style="width: 100px">
              <app-field>
                <app-select
                  [items]="ticketsCurrentFilter.assignDaysList"
                  (callback)="ticketsCurrentFilter.changeDayForAssigment($event)"
                  [textKey]="'name'"
                  [defaultText]="'Выберите тип'"
                  [initBy]="ticketsCurrentFilter.assignDaySelected"
                  [name]="'ticketsTypeName'"
                ></app-select>
              </app-field>
            </div>
          </div>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="vertical-separate"></div>
      </div>
      <div class="grid__box grid__box--size-min">
        <button
          type="button"
          class="button"
          [disabled]="(brigadeAssign && brigadeAssign.brigades && !brigadeAssign.brigades.length) || brigadeAssign?.isAssignedLoading"
          (click)="assignBrigades()"
        >
          Отправить в работу
        </button>
      </div>
      <div class="grid__box grid__box--size-min">
        <button
          type="button"
          class="button automatic-distribution-button"
          [disabled]="!automaticDistribution || automaticDistribution.isChecking || automaticDistribution.isRunning"
          (click)="startAutomaticDistribution()"
        >
          AUTO
        </button>
      </div>
      <div class="grid__box grid__box--size-min" *ngIf="automaticDistribution && automaticDistribution.isChecking">
        <div class="pos-r automatic-distribution-loader">
          <app-loader [size]="'small'" [position]="'reset'"></app-loader>
        </div>
      </div>
      <div
        class="grid__box grid__box--size-min"
        *ngIf="brigadeAssign && brigadeAssign.brigades && brigadeAssign.brigades.length && !brigadeAssign?.isAssignedSuccess && !brigadeAssign?.isAssignedLoading"
      >
        <span class="text-italic color-gray-dark">
          Заявки на отправку:
          {{ brigadeAssign && brigadeAssign.brigades && brigadeAssign.brigades.length }}
        </span>
      </div>
      <div class="grid__box grid__box--size-min" *ngIf="brigadeAssign?.isAssignedLoading">
        <div class="pos-r">
          <app-loader [size]="'small'" [position]="'reset'"></app-loader>
        </div>
      </div>
      <div class="grid__box grid__box--size-min" *ngIf="brigadeAssign && brigadeAssign?.isAssignedSuccess && !brigadeAssign?.isAssignedLoading">
        <span class="text-italic color-green-dark">Заявки отправлены</span>
      </div>
    </div>
  </div>
  <div class="grid__box grid__box--pull-right grid__box--flex grid__box--justify-content-flex-end">
    <div class="grid grid--va-middle">
      <div class="grid__box grid__box--size-min" *ngIf="automaticDistribution">
        <div class="grid grid--gap-4 grid--va-middle">
          <div class="grid__box grid__box--size-min" (click)="toggleAutomaticDistributionMap()" title="Карта скорректированного маршрута">
            <app-icon
              [glyph]="'map'"
              [size]="'20'"
              [class]="'cur-pointer'"
              [color]="automaticDistribution.showMap ? 'blue-dark' : 'gray-dark'"
            ></app-icon>
          </div>
          <div class="grid__box grid__box--size-min" (click)="toggleAutomaticDistributionSchedule()" title="Скорректированное расписание">
            <app-icon
              [glyph]="'schedule-corrected'"
              [size]="'20'"
              [class]="'cur-pointer'"
              [color]="automaticDistribution.showSchedule ? 'blue-dark' : 'gray-dark'"
            ></app-icon>
          </div>
          <div class="grid__box grid__box--size-min">
            <div class="vertical-separate"></div>
          </div>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="grid grid--gap-4 grid--va-middle">
          <div class="grid__box grid__box--size-min" (click)="onChangeMode('table')">
            <app-icon [glyph]="'list'" [size]="'20'" [class]="'cur-pointer'" [color]="ticketsCurrentFilter.mode === 'table' ? 'blue-dark' : 'gray-dark'"></app-icon>
          </div>
          <div class="grid__box grid__box--size-min" (click)="onChangeMode('matrix')">
            <app-icon [glyph]="'cards'" [size]="'20'" [class]="'cur-pointer'" [color]="ticketsCurrentFilter.mode === 'matrix' ? 'blue-dark' : 'gray-dark'"></app-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
